import '@material-symbols/font-400/outlined.css';
import materialSymbolsUrl from '@material-symbols/font-400/material-symbols-outlined.woff2?url';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from './router';

import { App } from './App';
import { AuthProvider } from './auth';
import './styles.css';

const iconFontPreload = document.createElement('link');
iconFontPreload.rel = 'preload';
iconFontPreload.as = 'font';
iconFontPreload.type = 'font/woff2';
iconFontPreload.crossOrigin = 'anonymous';
iconFontPreload.href = materialSymbolsUrl;
document.head.append(iconFontPreload);

createRoot(document.getElementById('root')!).render(<React.StrictMode><BrowserRouter><AuthProvider><App /></AuthProvider></BrowserRouter></React.StrictMode>);
